<template>
    <Head title="Dashboard" />

    <div class="mx-auto max-w-6xl" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left mb-8">
            <div>
                <Teaser :headlines="translate('teaser:headlines')" :small="true" :subline="translate('teaser:subline')"></Teaser>
            </div>
        </div>
        <div class="px-4 sm:px-6 lg:px-8">
            <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                <li class="col-span-1 flex flex-col divide-y divide-gray-200 text-center border-dashed border-gray-300 border-2 ">
                    <div class="flex flex-1 flex-col mt-2">
                        <a :href="route('home')" class="">
                            <PlusIcon class="mx-auto h-16 w-16 mt-16 mb-16 text-green-500" aria-hidden="true" />
                        </a>
                        <a :href="route('home')" class="mt-4 text-sm font-medium text-white">{{ translate('body:create') }}</a>
                    </div>
                </li>
                <li v-for="nft in nfts" :key="nft.id" class="col-span-1 flex flex-col divide-y divide-gray-200 bg-white text-center">
                    <div class="flex flex-1 flex-col mt-2">
                        <a :href="route('nft_localized', {nft: nft.id})" target="_blank" v-if="nft.currentStage === 'MINTED' && nft.isHosted">
                            <img class="mx-auto w-full flex-shrink-0" style="aspect-ratio: 3/2; object-fit: contain;" :src="nft.localThumbFileUrl" alt="" />
                        </a>
                        <img class="mx-auto w-full flex-shrink-0" style="aspect-ratio: 3/2; object-fit: contain;" :src="nft.localThumbFileUrl" alt="" v-if="!(nft.currentStage === 'MINTED' && nft.isHosted)"/>
                        <h3 class="mt-4 text-sm font-medium text-gray-900">{{ nft.metaName  || translate('body:noname') }}</h3>
                        <dl class="mt-1 mb-5 flex flex-grow flex-col justify-between">
                            <dd class="text-sm text-gray-500">{{ translateAll('upload-' + nft.metaDataType + '.meta.title') }}</dd>
                        </dl>
                    </div>
                    <!-- Not finished -->
                    <div v-if="nft.currentStage === 'UNFINISHED'" class="inline-flex shadow bg-yellow-300 p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translate('body:state')}}:</strong>&nbsp;{{ translateAll('dashboard.stages.UNFINISHED') }}
                    </div>
                    <div v-if="nft.currentStage === 'LIMBO' && nft.futureStage === null" class="inline-flex shadow bg-gray-100 p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translate('body:state')}}:</strong>&nbsp;{{ translateAll('dashboard.stages.LIMBO') }}
                    </div>
                    <div v-if="nft.currentStage === 'MINTED' && nft.futureStage === null" class="inline-flex shadow bg-green-300 p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translateAll('dashboard.stages.MINTED') }}
                            <span v-if="nft.isHosted">&amp; {{ translateAll('dashboard.stages.HOSTED') }}</span></strong>

                    </div>
                    <div v-if="nft.currentStage === 'BURNED' && nft.futureStage === null" class="inline-flex shadow bg-red-300 p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translateAll('dashboard.stages.BURNED') }}</strong>
                    </div>
                    <div v-if="nft.currentStage === 'TRANSFERRED' && nft.futureStage === null" class="inline-flex shadow bg-gray-100 p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translateAll('dashboard.stages.TRANSFERRED') }}</strong>
                    </div>
                    <div v-if="nft.futureStage === 'MINTED' && !nft.futureStageByRemint" class="inline-flex shadow bg-orange-600 text-white p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translate('body:statewait')}}:</strong>&nbsp;
                        {{ translateAll('dashboard.futureStages.MINTED') }}
                        <LoadingDots />
                    </div>
                    <div v-if="nft.futureStage === 'MINTED' && nft.futureStageByRemint" class="inline-flex shadow bg-orange-600 text-white p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translate('body:statewait')}}:</strong>&nbsp;
                        {{ translateAll('dashboard.futureStages.REMINTED') }}
                        <LoadingDots />
                    </div>
                    <div v-if="nft.futureStage === 'BURNED'" class="inline-flex shadow bg-orange-600 text-white p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translate('body:statewait')}}:</strong>&nbsp;
                        {{ translateAll('dashboard.futureStages.BURNED') }}
                        <LoadingDots />
                    </div>
                    <div v-if="nft.futureStage === 'TRANSFERRED'" class="inline-flex shadow bg-orange-600 text-white p-1 px-2 text-xs font-normal uppercase leading-5 items-center justify-center">
                        <strong>{{ translate('body:statewait')}}:</strong>&nbsp;
                        {{ translateAll('dashboard.futureStages.TRANSFERRED') }}
                        <LoadingDots />
                    </div>
                    <div>
                        <div class="-mt-px flex">
                            <div class="flex w-0 flex-1" v-if="nft.currentStage === 'MINTED' && nft.isHosted">
                                <a :href="route('nft', {nft: nft.id})" target="_blank" class="cursor-pointer    relative ml-3 inline-flex w-0 flex-1 items-start justify-start rounded-bl-lg border border-transparent py-4 text-sm font-normal text-gray-700 hover:text-gray-500">
                                    <span class="inline-flex">
                                        <ArrowUpRightIcon class="mr-1 mt-0.5 h-4 w-4" aria-hidden="true" />
                                        {{ translate('body:websiteButton') }}
                                    </span>
                                </a>
                            </div>
                            <div class="flex w-0 flex-1" v-if="nft.currentStage === 'UNFINISHED'">
                                <a :href="route('loc_upload_meta', {nft: nft.id, metaDataType: nft.metaDataTypePath, locale: nft.localePath})" target="_blank" class="cursor-pointer    relative ml-3 inline-flex w-0 flex-1 items-start justify-start rounded-bl-lg border border-transparent py-4 text-sm font-normal text-gray-700 hover:text-gray-500">
                                    <span class="inline-flex">
                                        <ArrowUpRightIcon class="mr-1 mt-0.5 h-4 w-4" aria-hidden="true" />
                                        {{ translate('body:continueUnfinishedButton') }}
                                    </span>
                                </a>
                            </div>
                            <Menu as="div" class="relative -ml-px flex w-full flex-1" v-if="nft.futureStage !== null && nft.futureStageCanBeCancelled">
                                <div class="flex w-0 flex-1">
                                    <Link method="post" :href="route('dashboard_nft_cancel_localized', {nft: nft.id, process: nft.futureStageProcess})" class="cursor-pointer relative ml-3 inline-flex w-0 flex-1 items-start justify-start rounded-bl-lg border border-transparent py-4 text-sm font-normal text-gray-700 hover:text-gray-500">
                                    <span class="inline-flex">
                                        <XMarkIcon class="mr-1 mt-0.5 h-4 w-4" aria-hidden="true" />
                                        {{ translate('body:cancelButton') }}
                                    </span>
                                    </Link>
                                </div>
                            </Menu>
                            <Menu as="div" class="relative -ml-px flex w-full flex-1" v-if="nft.futureStage === null && nft.currentStage !== 'TRANSFERRED' && nft.currentStage !== 'LIMBO'">
                                <MenuButton class="relative inline-flex w-full flex-1 items-end justify-end rounded-br-lg py-4 text-sm font-medium text-gray-700 hover:text-gray-500">
                                    <span class="sr-only">{{ translate('body:actionButton') }}</span>
                                    <EllipsisVerticalIcon class="mr-4 ml-2 h-6 w-6 p-1 bg-gray-100 rounded-full hover:bg-gray-200" aria-hidden="true" />
                                </MenuButton>

                                <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                    <MenuItems class="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <div class="py-1">
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage === 'BURNED'">
                                                <a href="#" @click="showRecreateDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <CloudArrowUpIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:recreate') }}
                                                </a>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage === 'BURNED'">
                                                <a href="#" @click="showDeleteBurnedDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <FireIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:deleteBurnedButton') }}
                                                </a>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage === 'UNFINISHED'">
                                                <a href="#" @click="showDeleteUnfinishedDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <TrashIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:deleteUnfinishedButton') }}
                                                </a>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage === 'MINTED' || nft.currentStage === 'BURNED'">
                                                <a href="#" @click="showMetaDataDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <PencilIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:metaEditButton') }}
                                                </a>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage === 'MINTED'">
                                                <a href="#" @click="showBurnDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <FireIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:burnButton') }}
                                                </a>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage === 'MINTED'">
                                                <a href="#" @click="showTransferDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <PaperAirplaneIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:transferButton') }}
                                                </a>
                                            </MenuItem>
                                        </div>
                                        <div class="py-1">
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage !== 'UNFINISHED'">
                                                <a href="#" @click="showBillingDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <BanknotesIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:billingButton') }}
                                                </a>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage !== 'UNFINISHED'">
                                                <a :href="nft.subscription" target="_blank" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <CreditCardIcon class="mr-3 h-4 w-4 text-gray-800" aria-hidden="true" />
                                                    {{ translate('body:subscriptionButton') }}
                                                </a>
                                            </MenuItem>
                                        </div>
                                        <div class="py-1">
                                            <MenuItem v-slot="{ active }" v-if="nft.currentStage !== 'UNFINISHED'">
                                                <a href="#" @click="showTransactionsDialog(nft)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-xs']">
                                                    <img class="h-4 w-4 mr-3" src="/img/polygon-matic-logo.svg" alt="" />
                                                    {{ translate('body:transactionsButton') }}
                                                </a>
                                            </MenuItem>
                                        </div>
                                    </MenuItems>
                                </transition>
                            </Menu>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <Burn ref="burnDialog" @close="closedDialog()"/>
    <Recreate ref="recreateDialog" @close="closedDialog()" />
    <DeleteUnfinished ref="deleteUnfinishedDialog" @close="closedDialog()" />
    <Transfer ref="transferDialog" @close="closedDialog()" />
    <MetaData ref="metaDataDialog" @close="closedDialog()" />
    <DeleteBurned ref="deleteBurnedDialog" @close="closedDialog()" />
    <Transactions ref="transactionsDialog" @close="closedDialog()" />
    <Billing ref="billingDialog" @close="closedDialog()" />

</template>

<script>
import {Head, usePage} from '@inertiajs/inertia-vue3'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ExclamationTriangleIcon, BanknotesIcon, CreditCardIcon } from '@heroicons/vue/24/outline'
import Teaser from "../../Components/Common/Teaser";
import translate from "../../../lang";
import {computed, ref} from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Link } from '@inertiajs/inertia-vue3'
import { EnvelopeIcon, PhoneIcon } from '@heroicons/vue/20/solid'
import {
    FireIcon,
    PlusIcon,
    CloudArrowUpIcon,
    PaperAirplaneIcon,
    ArchiveBoxIcon,
    ArrowRightCircleIcon,
    ChevronDownIcon,
    DocumentDuplicateIcon,
    HeartIcon,
    PencilIcon,
    TrashIcon,
    UserPlusIcon,
    ShareIcon,
    DocumentMagnifyingGlassIcon,
    ArrowUpRightIcon,
    XMarkIcon,
    EllipsisVerticalIcon
} from '@heroicons/vue/20/solid'
import {
    ArrowPathIcon,
    ClockIcon,
    LinkIcon
} from '@heroicons/vue/24/outline';

import {Inertia} from "@inertiajs/inertia";
import Burn from './Dialogs/Burn';
import Transfer from './Dialogs/Transfer';
import Recreate from './Dialogs/Recreate';
import DeleteUnfinished from "./Dialogs/DeleteUnfinished";
import MetaData from "./Dialogs/MetaData";
import DeleteBurned from "./Dialogs/DeleteBurned";
import Transactions from "./Dialogs/Transactions";
import Billing from "./Dialogs/Billing";
import LoadingDots from "./Components/LoadingDots";

export default {
    components: {
        XMarkIcon,
        CreditCardIcon,
        LoadingDots,
        BanknotesIcon,
        EllipsisVerticalIcon,
        DeleteUnfinished,
        Burn,
        Recreate,
        Transfer,
        MetaData,
        DeleteBurned,
        Transactions,
        Billing,
        CloudArrowUpIcon,
        LinkIcon,
        Teaser,
        Link,
        Head,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ArchiveBoxIcon,
        ArrowRightCircleIcon,
        ChevronDownIcon,
        DocumentDuplicateIcon,
        HeartIcon,
        PencilIcon,
        TrashIcon,
        UserPlusIcon,
        PaperAirplaneIcon,
        DocumentMagnifyingGlassIcon,
        ArrowUpRightIcon,
        FireIcon,
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        ExclamationTriangleIcon,
        ShareIcon,
        ArrowPathIcon,
        ClockIcon,
        PlusIcon
    },
    props: {
        nfts: Array
    },
    setup(props) {
        function showBurnDialog(nft) {
            dialogOpen.value = true;
            burnDialog.value.show(nft);
        }
        function showBillingDialog(nft) {
            dialogOpen.value = true;
            billingDialog.value.show(nft);
        }
        function showMetaDataDialog(nft) {
            dialogOpen.value = true;
            metaDataDialog.value.show(nft);
        }
        function showRecreateDialog(nft) {
            dialogOpen.value = true;
            recreateDialog.value.show(nft);
        }
        function showDeleteUnfinishedDialog(nft) {
            dialogOpen.value = true;
            deleteUnfinishedDialog.value.show(nft);
        }
        function showDeleteBurnedDialog(nft) {
            dialogOpen.value = true;
            deleteBurnedDialog.value.show(nft);
        }
        function showTransferDialog(nft) {
            dialogOpen.value = true;
            transferDialog.value.show(nft);
        }
        function showTransactionsDialog(nft) {
            dialogOpen.value = true;
            transactionsDialog.value.show(nft);
        }

        const burnDialog = ref(null);
        const transferDialog = ref(null);
        const recreateDialog = ref(null);
        const deleteUnfinishedDialog = ref(null);
        const deleteBurnedDialog = ref(null);
        const metaDataDialog = ref(null);
        const transactionsDialog = ref(null);
        const billingDialog = ref(null);

        let dialogOpen = ref(false);
        let closedDialog = function() {
            dialogOpen.value = false;
        }

        let returnOptions = {
            closedDialog,
            dialogOpen,
            showBillingDialog,
            billingDialog,
            showTransactionsDialog,
            transactionsDialog,
            showMetaDataDialog,
            metaDataDialog,
            showDeleteBurnedDialog,
            deleteBurnedDialog,
            burnDialog,
            showBurnDialog,
            transferDialog,
            showTransferDialog,
            recreateDialog,
            showRecreateDialog,
            deleteUnfinishedDialog,
            showDeleteUnfinishedDialog,
            translate: translate('dashboard.list'),
            translateAll: translate(),
        };
        props.nfts.forEach(nft => returnOptions['metaDataDialog' + nft.id] = ref(null));

        setInterval(function() {
            if(!dialogOpen.value) {
                Inertia.reload({preserveScroll: true, preserveState: true});
            }
        }, 5000);

        return returnOptions;
    }
}
</script>
